var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M15.5532 2.46168L13.4982 0.40668C13.2299 0.154752 12.8785 0.0101997 12.5107 0.000519568C12.1428 -0.00916052 11.7842 0.116708 11.5032 0.354181L4.75315 7.10418C4.51073 7.34865 4.35978 7.66908 4.32565 8.01168L4.00315 11.1392C3.99305 11.249 4.0073 11.3598 4.0449 11.4635C4.08249 11.5672 4.1425 11.6613 4.22065 11.7392C4.29073 11.8087 4.37384 11.8637 4.46522 11.901C4.5566 11.9383 4.65445 11.9573 4.75315 11.9567H4.82065L7.94815 11.6717C8.29075 11.6376 8.61118 11.4866 8.85565 11.2442L15.6057 4.49418C15.8676 4.21741 16.0092 3.84806 15.9994 3.46708C15.9895 3.0861 15.8291 2.72456 15.5532 2.46168ZM7.81315 10.1717L5.56315 10.3817L5.76565 8.13168L10.0032 3.94668L12.0282 5.97168L7.81315 10.1717ZM13.0032 4.96668L10.9932 2.95668L12.4557 1.45668L14.5032 3.50418L13.0032 4.96668Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    width: 20,
    height: 19.957,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.52750b04.svg";
export { ForwardRef as ReactComponent };